module.exports = __webpack_public_path__ + "static/ab-d6bc31aa0e05f494a7fc569567c33f67.png";